import { useQuery } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// What deleting a payer would take with it — surfaced in the agency
// directory's delete confirmation before committing to the cascade.
export function usePayerDeleteImpact(payerId: string | null) {
  const query = useQuery({
    queryKey: payerKeys.deleteImpact(payerId ?? ''),
    queryFn: () => payersApi.getPayerDeleteImpact(payerId as string),
    enabled: !!payerId,
  });

  return { ...query, impact: query.data ?? null };
}
